const bioStandardSingle = Object.freeze([
  {
    blockId: 11,
    size: {
      w: 2,
      h: 2
    },
    position: {
      y: 1,
      x: 1
    },
    content_type: 'asset',
    asset_type: 'photo',
    isTileCreator: true,
    blockSubtype: 'image',
    blockType: 'content',
    tile_inner_zf_image: {
      cropData: {
        borderRadius: 0
      }
    },
    alt_text: 'Standard image',
  },
  {
    blockId: 12,
    size: {
      w: 2,
      h: 2
    },
    position: {
      y: 1,
      x: 3
    },
    tile_caption: '<h2><em>Jenny Smith</em></h2><h4>Managerial manager</h4><h4>California, USA</h4><p>In condimentum mauris id leo varius, molestie luctus eros suscipit. Morbi a enim consectetur, fringilla ligula non, auctor dolor. Ut ut ligula a tellus volutpat efficitur. In at purus mattis.&nbsp;</p><p>In condimentum mauris id leo varius, molestie luctus eros suscipit. Morbi a enim consectetur, fringilla ligula non, auctor.</p>',
    content_type: 'text',
    blockType: 'content',
    blockSubtype: 'text',
    isTileCreator: false
  }
]);

export default bioStandardSingle;